module.exports = __webpack_public_path__ + "assets/img/free_3.67eb02dd.png";